import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7 1.3c1.9 0 2.1 0 2.9.1 1.9.1 2.8 1 2.9 2.9V7c0 1.9 0 2.1-.1 2.8-.1 1.9-1 2.8-2.9 2.9-.8.1-.9.1-2.9.1-1.9 0-2.1 0-2.8-.1-1.9-.1-2.8-1-2.9-2.9.1-.8.1-.9.1-2.8s0-2.1.1-2.8c.1-1.9 1-2.8 2.9-2.9zM7 0C5.1 0 4.8 0 4.1.1 1.5.2.1 1.6 0 4.2V7c0 1.9 0 2.2.1 2.9.1 2.6 1.5 4 4.1 4.1H7c1.9 0 2.2 0 2.9-.1 2.6-.1 4-1.5 4.1-4.1V7c0-1.9 0-2.2-.1-2.9-.1-2.6-1.5-4-4.1-4.1zm0 3.4C5 3.4 3.4 5 3.4 7S5 10.6 7 10.6 10.6 9 10.6 7 9 3.4 7 3.4m0 5.9c-1.3 0-2.3-1-2.3-2.3s1-2.3 2.3-2.3 2.3 1 2.3 2.3-1 2.3-2.3 2.3m3.7-6.8c-.5 0-.8.3-.8.8s.4.8.8.8c.5 0 .8-.4.8-.8.1-.5-.3-.8-.8-.8" }, null, -1)
  ])))
}
export default { render: render }